/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, June 2020
 */

import { parse } from 'querystring';
import { FlowState } from '@staffino/model';
import CachedFlowBridge from '../flow/cached-flow-bridge';

export default class MerakiFlowBridge extends CachedFlowBridge {
  // TODO: rename to submitForm
  async commitState(state: FlowState): Promise<void> {
    const queryParams = parse(location.search?.substring(1));

    // find email and/or phone
    // TODO: move to the email
    // const filledInputs = Object.values(data.inputs).filter(input => !!input.value);
    // const emailInput = filledInputs.find(input => input.name === 'customer.email') ??
    //   filledInputs.find(input => input.type === 'Email');
    // const phoneInput = filledInputs.find(input => input.name === 'customer.phone') ??
    //   filledInputs.find(input => input.type === 'Phone');

    // if (emailInput || phoneInput) {
    const url = `/api/meraki/registration`;
    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'error',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({
        flowId: this.flowId,
        // email: emailInput?.value,
        // phone: phoneInput?.value,
        clientMac: queryParams.client_mac,
        nodeMac: queryParams.node_mac,
        ...state,
      }),
    });
    // }

    const redirectUrl = queryParams.base_grant_url as string;
    if (redirectUrl) {
      location.href = redirectUrl;
    }
  }

  async saveState(state: FlowState): Promise<void> {
    // do nothing, we need to get to the end of the flow in splash screen
  }
}
